import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import { useTheme } from 'styled-components';
import { usePageBuilder } from '../../../builder/pageBuilderProvider';
import ContentfulLink from './ContentfulLink';
const Link = (link) => {
    const { handlePaymentPage } = usePageBuilder();
    const handleClick = (e) => {
        if (!link.action)
            return;
        e.stopPropagation();
        switch (link.action) {
            case 'paymentPage':
                handlePaymentPage();
                break;
            default:
                break;
        }
    };
    return (_jsx(ContentfulLink, { style: { width: link.fullWidth ? '100%' : 'fit-content' }, children: _jsx(FormattedButton, Object.assign({}, link, { handleClick: handleClick })) }));
};
const FormattedButton = ({ theme: defaultTheme, size, isFooterLegal, isFooterNav, style, handleClick, withArrow, fullWidth, shape, name, }) => {
    const isFooter = isFooterLegal || isFooterNav;
    const theme = useTheme();
    return (_jsx(Button, { isLink: defaultTheme === 'link' && !isFooter, transparent: defaultTheme === 'link' && isFooter, defaultStyle: !!defaultTheme && defaultTheme !== 'link'
            ? theme.colors[defaultTheme]
            : isFooterLegal
                ? theme.colors.grey_4
                : isFooterNav
                    ? theme.colors.white_1
                    : undefined, style: style, size: size, withArrowRight: withArrow, onClick: handleClick, fullWidth: fullWidth, shape: shape, children: name }));
};
export default Link;
